export default {"src":"https://images-cdn.curipod.com/d-4668ce59/_next/static/media/stars.e76db6a2.svg","height":270,"width":249};